<template>
    <b-modal 
        size="md" 
        :id="id"   
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        centered
    >
        <div class="text-center cost-saver-alert p-4">
            <i class="fas fa-exclamation-triangle text-danger" style="font-size: 3rem;"></i>
           
            <div class="alert-text mt-3 py-2">{{ message }}</div>

            <div class="mt-4 d-flex justify-content-center">
                <b-button variant="primary" @click="$bvModal.hide(id)">{{  $t("account-page-notif-control.schedule_pre_checkin_notice.sms_pre_checkin_notice.ok") }}</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import { BIconExclamationTriangleFill } from 'bootstrap-vue';

    export default {
        name: "warning-modal",
        props: ["id", "message"],
        components: {
            BIconExclamationTriangleFill,
        }
    }
</script>

<style scoped>
.cost-saver-alert {
    font-size: 14px;
    font-family: "Poppins", sans-serif;
}
</style>